import React from 'react';

const SectionWrapper = ({ 
  children, 
  className = 'introduction',
  title,
  titleTag: TitleTag = 'h3',
  extraMargin = false,
  tag: Tag = 'div'
}) => {
  let classes = className;
  
  if (extraMargin && className.includes('introduction')) {
    classes = `${className} extra-margin`;
  }

  return (
    <Tag className={classes}>
      {title && <TitleTag>{title}</TitleTag>}
      {children}
    </Tag>
  );
};

export default SectionWrapper;